import { BackendAgnosticSyncEngine } from "./engine/BackendAgnosticSyncEngine";
import { createSyncHandlerRegistry } from "./createSyncHandlerRegistry";

export const createSyncEngine = ({ localDataAccess, remoteDataAccess }) =>
  new BackendAgnosticSyncEngine({
    syncOperationRepository: localDataAccess.repositories.syncOperations,
    handlers: createSyncHandlerRegistry({
      localDataAccess,
      remoteDataAccess,
    }),
  });
